module.exports = __webpack_public_path__ + "img/shared-control.6dbdd201.svg";